<span [ngSwitch]="status.statusCode">
  <span class="badge-status grey" *ngSwitchCase="verificationTaskStatus.New">
    {{status.title}}
  </span>
  <span class="badge-status success-with-border" *ngSwitchCase="verificationTaskStatus.Active">
    {{status.title}}
  </span>
  <span class="badge-status orange_ff" *ngSwitchCase="verificationTaskStatus.Waiting_First_Review">
    {{status.title}}
  </span>
  <span class="badge-status purple" *ngSwitchCase="verificationTaskStatus.Modifications_Requested_From_First_Review">
    {{status.title}}
  </span>
  <span class="badge-status orange_ff" *ngSwitchCase="verificationTaskStatus.Waiting_Final_Review">
    {{status.title}}
  </span>
  <span class="badge-status orange_ff" *ngSwitchCase="verificationTaskStatus.Modifications_Requested_From_Final_Review">
    {{status.title}}
  </span>
  <span class="badge-status orange_ff" *ngSwitchCase="verificationTaskStatus.Waiting_Final_Approval">
    {{status.title}}
  </span>
  <span class="badge-status success-with-border" *ngSwitchCase="verificationTaskStatus.Final_Report_Approved">
    {{status.title}}
  </span>
  <span class="badge-status red_2" *ngSwitchCase="verificationTaskStatus.Final_Report_Rejected">
    {{status.title}}
  </span>
  <span class="badge-status danger-with-border" *ngSwitchCase="verificationTaskStatus.Overdue">
    {{status.title}}
  </span>
  <span class="badge-status danger-with-border" *ngSwitchCase="verificationTaskStatus.Escalate_To_Related_Entity">
    {{status.title}}
  </span>
</span>